// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MOm3","badges":"styles_badges__uI0E2"};